/**
 * Base da camada de plataforma.
 *
 * Todo o resto de src/platform/ passa por aqui para decidir se roda a
 * implementacao nativa (app das lojas, via Capacitor) ou a web (navegador /
 * PWA). Os componentes em src/components/ nao devem checar plataforma
 * diretamente — eles importam o adaptador e recebem a mesma API nos dois lados.
 *
 * POR QUE `window.Capacitor` E NAO `import { Capacitor } from '@capacitor/core'`:
 * o runtime do Capacitor injeta `window.Capacitor` (com `Plugins`) no webview
 * antes do bundle carregar. Usando o global, frontend/package.json continua sem
 * nenhuma dependencia de Capacitor — o build web do Railway segue byte-a-byte
 * o que era antes, e nao existe risco de o deploy de producao quebrar por causa
 * do app. Todo plugin oficial se registra em `window.Capacitor.Plugins`, entao
 * nao perdemos nada alem dos types (o projeto e JS puro de qualquer forma).
 */

function bridge() {
  return typeof window !== 'undefined' ? window.Capacitor : undefined;
}

/** true dentro do app das lojas (iOS/Android); false no navegador e no PWA. */
export function isNative() {
  const cap = bridge();
  return !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
}

/** 'ios' | 'android' | 'web' */
export function getPlatform() {
  const cap = bridge();
  if (cap && typeof cap.getPlatform === 'function') return cap.getPlatform();
  return 'web';
}

export function isIOS() {
  return getPlatform() === 'ios';
}

export function isAndroid() {
  return getPlatform() === 'android';
}

/**
 * Devolve um plugin do Capacitor pelo nome, ou null se nao estiver disponivel
 * (rodando na web, ou plugin ainda nao instalado no projeto nativo).
 *
 * Sempre tratar o null: o mesmo codigo roda no navegador, onde nenhum plugin
 * existe. Ex.:
 *
 *   const Camera = getPlugin('Camera');
 *   if (!Camera) return fallbackWeb();
 */
export function getPlugin(nome) {
  const cap = bridge();
  const plugin = cap && cap.Plugins ? cap.Plugins[nome] : undefined;
  return plugin || null;
}

/** true se o plugin estiver disponivel nesta plataforma. */
export function hasPlugin(nome) {
  return getPlugin(nome) !== null;
}
